/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeRawBodyRequest, type ErrorResponse, type InternalErrorResponse, type RawBodyRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/emails/resend-webhook
 */
export interface ResendWebhookRequestBuilder extends BaseRequestBuilder<ResendWebhookRequestBuilder> {
    /**
     * Receives Resend email delivery events and records each one against the email it reports on. Every delivery must carry valid svix-id, svix-timestamp and svix-signature headers, signed within the last five minutes.
     * @param body A webhook delivery taken as raw text, so the bytes that were signed are the bytes that getverified — parsing first and re-serializing would change them and break the signature.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: RawBodyRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * Receives Resend email delivery events and records each one against the email it reports on. Every delivery must carry valid svix-id, svix-timestamp and svix-signature headers, signed within the last five minutes.
     * @param body A webhook delivery taken as raw text, so the bytes that were signed are the bytes that getverified — parsing first and re-serializing would change them and break the signature.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: RawBodyRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ResendWebhookRequestBuilderUriTemplate = "{+baseurl}/api/emails/resend-webhook";
/**
 * Metadata for all the requests in the request builder.
 */
export const ResendWebhookRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ResendWebhookRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRawBodyRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
